import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Page from 'components/Page';
import Pagination from 'components/Pagination';
import Search from 'components/Search';
import TravelDocumentsList from 'components/TravelDocumentsList';
import EntityListPageSkeleton from 'components/OrderListPageSkeleton';

import { makeAfter, withData } from 'lib';
import { makeFilter } from 'components/PackageList';

import { SettingsTravelDocumentListPageQuery } from '__generated__/SettingsTravelDocumentListPageQuery.graphql';

const query = graphql`
  query SettingsTravelDocumentListPageQuery($first: Int!) {
    ...TravelDocumentsList_data @arguments(first: $first)
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<SettingsTravelDocumentListPageQuery>;
};

const breadcrumbs = [
  { link: '/settings', name: 'Nustatymai' },
  { name: 'Kelionės dokumentai' },
];

const SettingsTravelDocumentListPage = ({ preloadedQuery }: Props) => {
  const data = usePreloadedQuery<SettingsTravelDocumentListPageQuery>(
    query,
    preloadedQuery
  );

  return (
    <Page breadcrumbs={breadcrumbs}>
      <Pagination>
        <Search>
          <TravelDocumentsList data={data} />
        </Search>
      </Pagination>
    </Page>
  );
};

export default withData<SettingsTravelDocumentListPageQuery>({
  query,
  reloadOnRender: false,
  loading: <EntityListPageSkeleton breadcrumbs={breadcrumbs} cols={1} />,

  variables: ({ currentUser, searchParams }) => ({
    first: currentUser.itemsPerPage,
    filters: makeFilter(searchParams),
    after: makeAfter(
      Number(searchParams.get('page')) || 0,
      currentUser.itemsPerPage
    ),
  }),
})(SettingsTravelDocumentListPage);
